<template>
    <div class="">
        <div>
            <ol class="breadcrumb fs-sm mb-1">
                <li class="breadcrumb-item">
                    <router-link to="/dashboard">Dashboard</router-link>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Roles</li>
            </ol>
            <h4 class="main-title mb-2">Roles</h4>
        </div>
        <div class="row">
            <div class="col-4" v-can="'role.create'">
                <form @submit.prevent="submitForm()">
                    <div class="card card-one">
                        <div class="card-header d-flex justify-content-between">
                            <h6 class="card-title" v-if="status">New Role</h6>
                            <h6 class="card-title" v-else>Update Role</h6>
                        </div>
                        <div class="card-body">
                            <div class="row g-2">
                                <div class="col-md-12">
                                    <label class="form-label">Role Code</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Role Code" :class="{ 'is-invalid': errors.role_code }" class="form-control" v-model="role.role_code" ref="role_code" />
                                    <span v-if="errors.role_code"><small class="text-danger">{{ errors.role_code[0] }}</small></span>
                                </div>
                                <div class="col-md-12">
                                    <label class="form-label">Role Name</label><span class="text-danger"> *</span>
                                    <input type="text" placeholder="Role Name" :class="{ 'is-invalid': errors.role_name }" class="form-control" v-model="role.role_name" />
                                    <span v-if="errors.role_name"><small class="text-danger">{{ errors.role_name[0] }}</small></span>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer text-end">
                            <button type="button" class="btn btn-danger me-2" @click="discard()"><i class="ri-close-line fs-18 lh-1"></i> Discard</button>
                            <button type="submit" class="btn btn-primary" >
                                <span v-if="status"><i class="ri-save-line fs-18 lh-1"></i> Submit</span>
                                <span v-else><i class="ri-save-line fs-18 lh-1"></i> Update</span>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <div :class="column">
                <div class="card card-one">
                    <div class="card-header d-flex justify-content-between">
                        <h6 class="card-title">Roles</h6>
                    </div>
                    <div class="card-body">
                        <input class="form-control mb-2" type="text" placeholder="Type keyword and press enter key" v-model="meta.search" @keypress.enter="search()"/>
                        <div class="table-responsive table-responsive-sm">
                            <table class="table table-sm table-striped text-nowrap table-bordered mb-0">
                                <thead>
                                    <tr style="background-color: #9b9b9b; color: white;">
                                        <th class="text-center">#</th>
                                        <th @click="sort('role_code')">
                                            Role Code
                                            <span>
                                                <i v-if="meta.keyword=='role_code' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword=='role_code' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th @click="sort('role_name')">
                                            Role Name
                                            <span>
                                                <i v-if="meta.keyword=='role_name' && meta.order_by=='asc'" class="ri-arrow-up-line"></i>
                                                <i v-else-if="meta.keyword=='role_name' && meta.order_by=='desc'" class="ri-arrow-down-line"></i>
                                                <i v-else class="fas fa-sort"></i>
                                            </span>
                                        </th>
                                        <th class="text-center" v-can="'role.delete'">Status</th>
                                        <th class="text-center" v-can="'role.update'">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="roles.length==0">
                                        <td colspan="5" class="text-center">No records found</td>
                                    </tr>
                                    <tr v-for="role, key in roles" :key="key">
                                        <td class="text-center">{{ meta.from + key }}</td>
                                        <td>{{ role.role_code }}</td>
                                        <td>{{ role.role_name }}</td>
                                        <td class="text-center" v-can="'role.delete'">
                                            <div class="form-switch">
                                                <input class="form-check-input" type="checkbox" role="switch" :id="'role' + role.role_id" :checked="role.status" :value="role.status" @change="deleteRole(role)" />
                                                <label class="custom-control-label" :for="'role' + role.role_id"></label>
                                            </div>
                                        </td>
                                        <td class="text-center" v-can="'role.update'">
                                            <a href="javascript:void(0)" v-if="role.status" class="text-success me-2" @click="editRole(role)"><i class="ri-pencil-line fs-18 lh-1"></i></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="d-flex justify-content-between align-items-center">
                            <select class="form-select from-select-sm width-75" v-model="meta.per_page" @change="onPerPageChange">
                                <option>10</option>
                                <option>15</option>
                                <option>20</option>
                                <option>25</option>
                                <option>30</option>
                            </select>
                            <span>Showing {{ meta.from }} to {{ meta.to }} of {{ meta.totalRows }} entries</span>

                            <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination.vue";
    export default {
        components: {
            Pagination,
        },
        data() {
            return {
                column:'col-8',
                meta: {
                    search: "",
                    order_by: "asc",
                    keyword: "role_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    trashed: false,
                },
                role: {
                    role_id: "",
                    role_code: "",
                    role_name: "",
                },
                status: true,
                roles: [],
                errors: [],
            };
        },
        mounted() {
            this.create_role = this.$store.getters.permissions.filter(function(element){
                return element.ability.ability.includes('role.create')
            })
            if(this.create_role.length){
                this.column = 'col-8'
            }else{
                this.column = 'col-12'
            }
            this.index();
        },

        methods: {
            submitForm() {
                let vm = this;
                if (vm.status) {
                    vm.addRole();
                } else {
                    vm.updateRole();
                }
            },
            index() {
                let vm = this;
                vm.$store
                    .dispatch("post", { uri: "paginateRoles", data: vm.meta })
                    .then((response) => {
                        vm.roles = response.data.data;
                        vm.meta.totalRows = response.data.meta.total;
                        vm.meta.lastPage = response.data.meta.last_page;
                        vm.meta.from = response.data.meta.from;
                        vm.meta.to = response.data.meta.to;
                        vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            addRole() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "addRole", data: vm.role })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", "Role Added successfully");
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            updateRole() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "updateRole", data: vm.role })
                    .then((response) => {
                        loader.hide();
                        vm.$store.dispatch("success", "Role is successfully updated");
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            editRole(role) {
                let vm = this;
                vm.$refs.role_code.focus();
                vm.errors = [];
                vm.status = false;
                vm.role = role;
            },

            deleteRole(role) {
                let vm = this;
                let loader = vm.$loading.show();
                role.status = role.status == 1 ? 0 : 1;
                vm.$store
                    .dispatch("post", { uri: "deleteRole", data: role })
                    .then(function (response) {
                        loader.hide();
                        vm.$store.dispatch("success", response.data.message);
                        vm.discard();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            search() {
                let vm = this;
                vm.meta.page = 1;
                vm.index();
            },

            onPageChange(page) {
                let vm = this;
                vm.meta.page = page;
                vm.index();
            },
            sort(field) {
                let vm = this;
                vm.meta.keyword = field;
                vm.meta.order_by = vm.meta.order_by == "asc" ? "desc" : "asc";
                vm.index();
            },
            discard() {
                let vm = this;
                vm.role.role_code = "";
                vm.role.role_name = "";
                vm.$refs.role_code.focus();
                vm.errors = [];
                vm.status = true;
                vm.index();
            },
            onPerPageChange() {
                this.meta.page = 1;
                this.index();
            },
        },
    };
</script>
